import Vue from 'vue'
import { CostCenter } from '@/models'
import OverviewTab from './OverviewTab.vue'
import ProdutosTab from './ProdutosTab.vue'
import LancamentosTab from './LancamentosTab.vue'
import AtivarDesativarTab from './AtivarDesativarTab.vue'

export default new Vue({
  data() {
    return {
      currentTab: 'overview',
      id: null,
      row: null
    }
  },
  computed: {
    tabItems() {
      return [
        {
          value: 'overview',
          group: 'Geral',
          label: 'Cadastro',
          component: OverviewTab
        },
        {
          value: 'produtos',
          group: 'Geral',
          label: 'Produtos',
          component: ProdutosTab
        },
        {
          value: 'lancamentos',
          group: 'Geral',
          label: 'Últimos Lançamentos',
          component: LancamentosTab
        },
        {
          value: 'changeStatus',
          group: 'Operações',
          label: 'Desativar/Reativar',
          component: AtivarDesativarTab
        }
      ]
    }
  },
  methods: {
    async load(id) {
      this.id = id
      this.row = null
      const row = await CostCenter.findById(this.id)
      this.row = row
    },

    async reload() {
      return await this.load(this.id)
    }

    // async patch(body) {
    //   await Camera.patch(this.row.id, body)
    //   await this.load(this.row.id)
    // },

    // async deactivate() {
    //   await Camera.delete(this.row.id)
    //   await this.load(this.row.id)
    // }
  }
})
